import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import AllGiftCards from './AllGiftCards';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { dateFormatUtil } from '../Utilities';

import ReactExport from 'react-export-excel';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import styles from './banner_upload.module.scss';
import {
    getStorage,
    ref,
    uploadBytes,
    list,
    getDownloadURL
} from 'firebase/storage';

import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const pageSizes = [5, 10, 25, 50, 100];
const statusArray =[
    { key: 'Approved', value: 'Approved' },
    { key: 'Pending', value: 'Pending' },
    { key: 'Rejected', value: 'Rejected' },
]
const searchBy = [
    { key: 'Title', value: 'title' },
];


export function MaterialUIPickers(props) {
    
    var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();
    var firstDay = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();

const [selectedDate, setSelectedDate] = React.useState(firstDay);

const handleDateChange = (date) => {
    setSelectedDate(date);
    props.setDate(date);
};

return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container justifyContent="space-around">
            <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="none"
                id={props.id}
                label={props.label}
                value={selectedDate}
                onChange={handleDateChange}
                maxDate={new Date()}
                autoOk={true}
                KeyboardButtonProps={{
                    'aria-label': 'change date'
                }}
            />
        </Grid>
    </MuiPickersUtilsProvider>
);
}


class AllList extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        showGCList:false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'title',
        selectedItem:[],
        DownloadReady:false,
        reportModalShow:false,

        modalShow: false,
        editmode: 'Add',
        alert: 0,
        alertMessage: '',
        data: [],
        selectedRow: [],
        flag: true,
        title:'',
        thumbnail:''
    };
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };

        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'giftcards/all-category'
        )
            .then((response) => response.json())
            .then((responseData) => {
                this.setState({
                    PrevpageNumber: this.state.pageNumber,
                    PrevStartAt: this.state.StartAt,
                    PrevLastDocument: this.state.LastDocument,
                    PrevFirstDocument: this.state.FirstDocument
                });

                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.data,
                            flag: false,
                            alert: 0
                        });
                    }
                    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        if (event.target.value === ''){
            this.setState({ [event.target.name]: '' });
        }else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    
    

    listGC = (rowData) => {
        if (this._isMounted) {
            this.setState({ showGCList: true, selectedRow: rowData });
        }
    };
    
    hideOffers  = () => {
        if (this._isMounted) {
            this.setState({ showGCList: false,  selectedRow: [] });
        }
    };

    
    
    updateDetail= (item)=>{
        if (this._isMounted) {
        this.setState({thumbnail:item.thumbnail,title:item.title,selectedItem:item,editmode:'Edit', modalShow: true });
        }
    } 
    deleteDetail= (item)=>{
        if (this._isMounted) {
        this.setState({selectedItem:item,editmode:'Delete', modalShow: true });
        }
    } 
    
    UpdateConfirmed = () => {
        
        let data = {
            title: this.state.title?this.state.title:this.state.selectedItem.title,
            thumbnail:this.state.thumbnail?this.state.thumbnail:this.state.selectedItem.thumbnail,
            documentId: this.state.selectedItem.documentId?this.state.selectedItem.documentId:'',
            action: this.state.editmode,
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName
                ? this.props.user.FullName
                : 'Admin'
        };
        
        this.setState({
            pageNumber: this.state.PrevpageNumber,
            StartAt: this.state.PrevStartAt,
            LastDocument: this.state.PrevLastDocument,
            FirstDocument: this.state.PrevFirstDocument
        });
        RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            data,
            'giftcards/updateCategory'
        )
            .then((response) => response.json())
            .then((responseData) => {
                this.setState({ modalShow: false });
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    this.loadData();
                    if (this._isMounted) {
                        this.setState({selectedItem:[]});
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });

    }

    handleClose = () => {
        if (this._isMounted) {
            this.setState({selectedItem:[], modalShow: false ,reportModalShow: false});
        }
    };

    handleImageAsFile = (e) => {
        const file = e.target.files[0];
        const storage = getStorage();
        const fileName = new Date().getTime()
        const storageRef = ref(storage, 'CaleImages/' + fileName);

        uploadBytes(storageRef, file).then((snapshot) => {
             getDownloadURL(ref(storage, 'CaleImages/' + fileName)).then(
                async (imageUrl) => {
                    if (this._isMounted) {
                        this.setState({thumbnail:imageUrl});
                    }
                }
            );

            
        });
    };
    
    render() {
        const actions = [
            {
                icon: 'add',
                tooltip: 'Add new',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({thumbnail:'',title:'',editmode:'Add',modalShow: true, selectedItem: [] });
                    }
                }
            }
        ];

        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                {!this.state.showGCList && (
                    <div>
                        <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Gift Card Category
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>
                        <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>
                                    {this.state.search_by =='Status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {statusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}
                                    {this.state.search_by !=='Status' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>

                        <MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="Category"
                            columns={[
                                {
                                    title: 'Icon',
                                    field: 'thumbnail',
                                    render: (row) => (
                                        <div className={styles.small_thumbnail}>
                                            {row.thumbnail && row.thumbnail!='' &&<img src={row.thumbnail} />}
                                        </div>
                                    )
                                },
                                {
                                    title: 'Title',
                                    field: 'title',
                                    render: (row) => (
                                        <div>
                                            {row.title}
                                        </div>
                                    )
                                },
                                { title: 'Manage Gift Cards', field: '',
                                render: (row) => (
                                    <div>
                                        <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={(e) =>
                                            this.listGC(row)
                                        }
                                    >
                                        List
                                    </Button>

                                    
                                    </div>
                                ) },
                                { title: 'Action', field: '',
                                render: (row) => (
                                    <div>
                                        <EditIcon
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={(e) =>
                                                this.updateDetail(row)
                                            }
                                        />
                                        <DeleteIcon
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={(e) =>
                                                this.deleteDetail(row)
                                            }
                                        />

                                    
                                    </div>
                                ) },
                                
                                
                            ]}
                            data={this.state.data}
                            actions={actions}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.data.length <
                                    this.state.perPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {this.state.data.length >=
                                    this.state.perPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}

                {this.state.showGCList && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.hideOffers}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Manage {this.state.selectedRow.title} Category
                            </h4>
                        </Row>

                        <AllGiftCards Category={this.state.selectedRow} {...this.props} />
                    </div>
                )}

                <Modal  
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        {this.state.selectedItem.title ?<Modal.Title>{this.state.editmode}  {this.state.selectedItem.title}</Modal.Title>:<Modal.Title>Add New Category</Modal.Title>}
                    </Modal.Header>

                    <Modal.Body>
                    {this.state.editmode =='Delete' ?<p>
                    Are you sure you want to delete this item?
                    </p>:<Form.Row>
                    <Form.Group>
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                    placeholder="Enter title"
                                    type="text"
                                    name="title"
                                    value={this.state.title}
                                    onChange={this.onChangeValues}
                                    required
                                />
                    </Form.Group>
                    <Form.Group>
                    <div className={styles.thumbnail} >
                        <Form.Label>Thumbnail</Form.Label>
                        {this.state.thumbnail && <img src={this.state.thumbnail}/>}
                        <Tooltip title="Upload Thumbnail">
                            <IconButton aria-label="upload">
                                <label>
                                    <CloudUploadIcon />
                                    <input
                                        type="file"
                                        hidden
                                        onChange={this.handleImageAsFile}
                                    />
                                </label>
                            </IconButton>
                        </Tooltip>
                        </div>
                        
                                
                    </Form.Group>
                    </Form.Row>}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.UpdateConfirmed}>
                        {this.state.editmode =='Delete' ?<>Delete</>:<>
                        {this.state.selectedItem.title ?<>Update</>:<>Add New</>}
                        </>}
                        </Button>
                        
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }
}

export default AllList;
